import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import HolidayCalendar from '../../entities/holidayCalendar';
export function deleteHolidayCalendar(holidayCalendar: HolidayCalendar, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = holidayCalendar.id;}
const _work = workingSet();




holidayCalendar.status = 'D';
holidayCalendar.addedOn = newHRTimestamp();
holidayCalendar.addedBy = getCurrentUserId();
holidayCalendar.importSource = targetImportSource;
holidayCalendar.importId = mergeId;
store.dispatch(Actions.HolidayCalendarActions.removeHolidayCalendarQueue(holidayCalendar));
}


